import { OverviewDashboard } from '../../components/dashboards/OverviewDashboard';

export function OverviewPage() {
  return <OverviewDashboard />;
}